<template>
  <div class="c-table">
    <el-table
      height="100%"
      :data="data"
      :row-key="rowKey || null"
      highlight-current-row
      :header-row-style="{ color: '#3c3c3c' }"
      :row-style="{ color: '#6e6e6e' }"
      @selection-change="selectionChange"
      style="width: 100%"
      ref="cTable"
    >
      <el-table-column
        v-if="$listeners.selectionChange"
        type="selection"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        v-if="index"
        label="序号"
        type="index"
        width="50"
        align="center"
      ></el-table-column>
      <template v-for="(item, index) in tableColumns">
        <c-table-column
          v-if="item.children && item.children.length"
          :key="index"
          :tableColumn="item"
          :align="item.align || 'center'"
        ></c-table-column>

        <template v-else-if="item.name == 'custom'">
          <c-table-slot :item="item" :key="index"></c-table-slot>
        </template>
        <template v-else-if="item.name == 'status'">
          <c-table-slot :item="item" :key="index"></c-table-slot>
        </template>
        <el-table-column
          label="操作"
          fixed="right"
          v-else-if="item.name == 'contr'"
          :key="index"
          header-align="center"
          :min-width="item.minWidth || '120px'"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div class="contr-btn-group">
              <div
                class="contr-btn"
                title="详情"
                @click="handeShowDetail(scope.row)"
                v-if="$listeners.showDetail"
              >
                <!-- <i class="iconfont icon-xiangqing"></i> -->
                <img src="../../assets/images/icon/detail.png" />
              </div>
              <div
                class="contr-btn"
                title="授权"
                @click="handleAuthorization(scope.row)"
                v-if="$listeners.authorization"
              >
                <i class="iconfont icon-authoration"></i>
              </div>
              <div
                class="contr-btn"
                title="重置密码"
                @click="handleResetPwd(scope.row)"
                v-if="$listeners.resetPwd"
              >
                <i class="iconfont icon-password"></i>
              </div>
              <div
                v-if="$listeners.edit"
                class="contr-btn"
                title="编辑"
                @click="handeEdit(scope.row)"
              >
                <i class="iconfont icon-edit"></i>
              </div>
              <div
                v-if="$listeners.delete"
                class="contr-btn"
                title="删除"
                @click="handleDelete(scope.row.id)"
              >
                <i class="iconfont icon-shanchu"></i>
              </div>
              <div
                v-if="$listeners.export"
                class="contr-btn"
                title="导出"
                @click="handleExport(scope.row)"
              >
                <i class="iconfont icon-daochu3" style="font-size: 22px"></i>
              </div>
              <div
                v-if="$listeners.config"
                class="contr-btn"
                title="规则配置"
                @click="handleConfig(scope.row)"
              >
                <i class="iconfont icon-setting"></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.show"
          show-tooltip-when-overflow
          :class-name="item.className"
          :key="index"
          :width="item.width || 'auto'"
          :min-width="item.minWidth"
          v-bind="item"
          :align="item.align || 'center'"
        ></el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="$listeners.change"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      :page-size="pagination.pageSize"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 50, 100, 200, 1000]"
      @size-change="sizeChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import CTableColumn from "./src/CTableColumn.vue";
import CTableSlot from "./src/CTableSlot.vue";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    tableColumns: {
      type: Array,
      required: true,
    },
    rowKey: String,
    index: Boolean,
    options: {
      type: Object,
      default() {
        return {
          layout: "layout",
          total: "total",
          pageSize: "pageSize",
          currentPage: "currentPage",
          pageSizes: "pageSizes",
        };
      },
    },
    pagination: {
      type: Object,
      default() {
        let options = this.options;
        return {
          [options.layout]: "total, sizes, prev, pager, next, jumper",
          [options.total]: 0,
          [options.pageSize]: 10,
          [options.currentPage]: 1,
          [options.pageSizes]: [10, 20, 30, 40, 50],
        };
      },
    },
  },
  provide() {
    return {
      cTable: this,
    };
  },
  watch: {
    tableColumns: {
      handler(val) {
        this.$nextTick(() => {
          //在数据加载完，重新渲染表格
          this.$refs["cTable"].doLayout();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    CTableColumn,
    CTableSlot,
  },
  methods: {
    sizeChange(val) {
      this.pagination.pageSize = val;
      this.$emit("change", {
        pageSize: val,
      });
    },
    currentChange(val) {
      this.pagination.pageNum = val;
      this.$emit("change", {
        pageNum: val,
      });
    },
    selectionChange(val) {
      this.$emit("selectionChange", val);
    },
    // 详情
    handeShowDetail(data) {
      this.$emit("showDetail", data);
    },
    // 授权
    handleAuthorization(data) {
      this.$emit("authorization", data);
    },
    // 重置(密码)
    handleResetPwd(data) {
      this.$emit("resetPwd", data);
    },
    // 编辑
    handeEdit(data) {
      this.$emit("edit", data);
    },
    // 删除
    handleDelete(id) {
      this.$emit("delete", id);
    },
    // 规则配置(专业调整)
    handleConfig(data) {
      this.$emit("config", data);
    },
    // 导出
    handleExport(data) {
      this.$emit("export", data);
    },
  },
};
</script>

<style lang="less">
.c-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-table {
    flex: 1;
    // margin-bottom: 20px;
    .cell {
      height: 25px !important;
    }
  }
  .el-pagination {
    padding-top: 10px;
  }
  .el-table td,
  .el-table th.is-leaf {
    transition: all ease 0.38s;
    // border-bottom: none;
  }
  .el-table::before {
    height: 0;
  }
  .leave-btn {
    padding: 4px 10px;
  }
  .contr-btn {
    .detail-disabled {
      position: relative;
      &:before {
        content: "";
        width: 90%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 8%;
        background: rgba(128, 128, 128, 0.5);
        cursor: not-allowed;
        border-radius: 4px;
      }
    }
    img {
      width: 24px;
      height: 24px;
      vertical-align: bottom;
    }
    i {
      font-size: 24px;
      // 编辑
      &.icon-edit {
        color: #6eb52b;
      }
      // 删除
      &.icon-shanchu {
        color: #f68907;
      }
      // 重置密码
      &.icon-password {
        color: #1b7aff;
      }
      // 授权
      &.icon-authoration {
        color: #00b38a;
      }
      // 配置
      &.icon-setting {
        color: #1890ff;
      }
      // 详情
      &.icon-xiangqing {
        color: #00b38a;
      }
      // 取消脱敏
      &.icon-mingan-1 {
        color: #ea2c4e;
      }
      // 数据脱敏
      &.icon-mingan-0 {
        color: #63ba4d;
      }
      &.icon-export,
      &.icon-daochu3 {
        color: #1b7aff;
      }
      &.icon-qiyongyonghu {
        color: #63ba4d;
      }
      &.icon-jinyongyonghu {
        color: #e26262;
      }
    }
  }
}
</style>